export default __webpack_public_path__ + "static/media/marker-gray-blue-red.50ff987b.png";